<template>
  <div class="image-news-part">
    <Link :to="{path: detailUrl, query: {id: id}}" :title="title" target="_blank" class="image-news-title">
      <h4><span class="color-theme-red">【头条新闻】</span>{{ title }}</h4>
    </Link>
    <div class="image-news">
      <el-carousel height="270px" :interval="15000" arrow="hover" indicator-position="none" @change="carouselChange">
        <el-carousel-item v-for="item in list" :key="item.id">
          <div class="image-news-item">
            <Link :to="{path: detailUrl, query: {id: item.id}}" class="img-link" target="_blank">
              <img :alt="item.title" :src="item.coverImage" class="link-item">
            </Link>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div v-if="list.length > 0" class="pl-15 f-column-b">
      <div class="image-news-time">{{ time }}</div>
      <div class="image-news-content">{{ description }}</div>
      <a :href="moreBtnUrl" target="_blank">
        <div class="ljmore">
          <div class="ljmore1">了解更多</div>
          <div class="ljmore2">></div>
        </div></a>
    </div>
  </div>
</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import { NAV_MENU_CODE } from "@/utils/constant";

export default {
  name: "ImageNews",
  components: { Link },
  props: {
    list: {
      type: Array
    },
    columnCode: {
      type: String
    }
  },
  data() {
    return {
      title: "",
      description: "",
      id: "",
      time: ""
    };
  },
  // 监听属性 类似于data概念
  computed: {
    detailUrl() {
      return "/info/detail/" + NAV_MENU_CODE.XWLB
    },
    moreBtnUrl() {
      return "/info/list/" + NAV_MENU_CODE.XWLB
    }
  },
  watch: {
    // 监听 list 的变化
    list: {
      immediate: true, // 立即执行一次
      handler(newList) {
        if (newList?.length > 0) {
          const firstItem = newList[0];
          this.title = firstItem.title || "";
          this.id = firstItem.id || "";
          this.description = firstItem.description || "";
          this.time = firstItem.releaseTime || firstItem.formatterDate || "";
        }
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  // 方法集合
  methods: {

    carouselChange(e) {
      this.list?.forEach((item, i) => {
        if (i === e) {
          this.title = item.title || "";
          this.id = item.id || "";
          this.description = item.description || "";
          this.time = item.releaseTime || item.formatterDate || "";
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
.ljmore{
	flex-shrink: 0;
  width: 110px;
  height: 30px;
  line-height: 30px;
  background: #FFFFFF;
  border: 1px solid #E15717;
  font-size: 14px;
  color: #E15717;
  text-align:center;
  cursor: pointer;
  display: flex;
  margin-top: 25px;
}
.ljmore1 {
  width: 80px;
  background: #FFFFFF;
}
.ljmore2 {
  width: 30px;
  height: 29px;
  line-height: 29px;
  background: #E15717;
  color: #fff
}
.image-news-part{
  display: flex;
	position: relative;
	padding-top: 40px;
	height: 100%;
	.image-news-title{
		width: 100%;
		position: absolute;
		left: 0;
		top: 0;
		font-size: 24px;
		color: #333;
		line-height: 1;
		h4 {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}
}
.image-news-time{
	font-size: 14px;
	color: #999999;
	margin-bottom: 25px;
}
.image-news-content{
	width: 100%;
	min-height: 0;
	flex: 1;
  font-size: 16px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  word-wrap:break-word;
  word-break:normal;
  text-indent: 2em;
	line-height: 28px;
}
.image-news{
  width: 502px;
	flex-shrink: 0;
	height: 100%;
  .image-news-item{
    width: 100%;
    height: 100%;
    position: relative;
    .img-link{
      display: block;
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &:hover{
      img{
        opacity: 0.8;
      }
    }
  }
}
</style>
